// extracted by mini-css-extract-plugin
export default {"iata":"lebxT","additionalInfo":"qyu3V","transparent":"Og-3y","AirportIcon":"TsBtT","RailwaysIcon":"nkwv0","HotelsIcon":"_2hQhs","MapPointIcon":"_28H5R","skeleton-progress":"U32IV"};